import type { OpenAPIConfig } from "~/api";
import { ApiClient } from "~/api";
import { getEnvConfig } from "~/services/appConfig";

const getConfig = (): OpenAPIConfig => ({
  BASE: getEnvConfig().serverUrl,
  VERSION: "1",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "omit",
  TOKEN: undefined,
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: undefined,
});

let _apiClient: ApiClient | null = null;

export const apiClient = new Proxy({} as ApiClient, {
  get(_target, prop) {
    _apiClient ??= new ApiClient(getConfig());
    return (_apiClient as any)[prop];
  },
});
